<template>
  <v-dialog persistent v-model="rejectModal" width="500">
    <v-card>
      <v-card-title class="headline red lighten-1 white--text" default-title>Reject Trekking Request</v-card-title>

      <v-card-text class="px-0">
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 v-if="errors">
              <v-alert
                  :value="true"
                  color="error"
                  icon="warning"
                  outlined
                  v-for="(value, key) in errors"
                  :key="key"
              >
                <template v-for="(item, index) in value">{{ item }}</template>
              </v-alert>
            </v-flex>
            <v-flex xs12>
              <v-form ref="rejectForm" v-model="valid" lazy-validation class="pa-2">
                <v-textarea
                    label="Remarks"
                    outlined
                    v-model="rejectForm.remarks"
                    :rules="[rules.required]"
                ></v-textarea>
                <multiple-file-upload
                    label="Attachments"
                    v-model="rejectForm.attachements"
                    :required="false"
                ></multiple-file-upload>
              </v-form>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="red lighten-1"
            class="white--text"
            @click="rejectModal = false; rejectForm={}"
        >Cancel
        </v-btn>
        <v-btn color="blue darken-3" :loading="loading" class="white--text" @click="reject">Reject</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import {mapActions, mapGetters} from "vuex";
import MultipleFileUpload from "../MultipleFileUpload";
import {validationMixin} from "../../mixins/validationMixin";

export default {
  data: () => ({
    valid: true,
    rejectForm: {},
    errors: [],
    loading: false
  }),
  components: {
    MultipleFileUpload
  },
  mixins: [validationMixin],
  computed: {
    ...mapGetters("TrekkingSingle", ["trekkingData"]),
    rejectModal: {
      get() {
        return this.$store.state.TrekkingSingle.rejectModal;
      },
      set(value) {
        this.$store.commit("TrekkingSingle/setRejectModal", value);
      }
    }
  },
  methods: {
    ...mapActions("TrekkingSingle", ["rejectRequest"]),
    close() {
      this.rejectModal = false;
      this.rejectForm = {};
    },
    reject() {
      this.loading = true;
      if (this.$refs.rejectForm.validate()) {
        let formData = new FormData();
        formData.append('remarks', this.rejectForm.remarks);
        let attachments = this.rejectForm.attachements;
        if (attachments !== undefined) {
          for (let i = 0; i < attachments.length; i++) {
            formData.append(`files[${i}]`, attachments[i]);
          }
        }
        this.rejectRequest(formData)
            .then(res => {
              this.form = false;
              this.rejectForm = {};
              this.errors = null;
              this.loading = false;
              this.rejectModal = false;
              this.$store.commit("Notification/showSuccess", "Trekking permit rejected");
            })
            .catch(error => {
              this.loading = false;
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
              }
            });

      } else {
        this.loading = false;
        this.$store.commit("Notification/showError", "Invalid Form Data");
      }
    }

  },


};
</script>
